import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { Page, TableFooterPagingModule } from '../../../../core/components/table-footer-paging/table-footer-paging.component';
import { SmsHistoryItem } from '../../../../core/services/sms.service';
import { LayoutService } from '../../../layout/layout.service';

@Component({
    selector: 'app-ui-sms-list',
    templateUrl: './ui-sms-list.component.html',
    standalone: false,
})
export class UiSmsListComponent {
    @Input()
    rows: SmsHistoryItem[] = [];

    @Input()
    isLoading = false;

    @Input()
    // @ts-ignore TS2564
    page: Page;

    @Input()
    showCreate = true;

    @Output()
    onCreate = new EventEmitter();

    @Output()
    onSort = new EventEmitter();

    @Output()
    onSetPage = new EventEmitter();

    @Output()
    onPageLimit = new EventEmitter();

    constructor(public layoutService: LayoutService) {}

    createNew() {
        this.onCreate.emit();
    }

    // @ts-ignore TS7006
    sortTable(event) {
        this.onSort.emit(event);
    }
    // @ts-ignore TS7006
    setPage(event) {
        this.onSetPage.emit(event);
    }

    // @ts-ignore TS7006
    pageLimit(event) {
        this.onPageLimit.emit(event);
    }
}

@NgModule({
    declarations: [UiSmsListComponent],
    imports: [CommonModule, TableFooterPagingModule, NgxDatatableModule],
    exports: [UiSmsListComponent],
})
export class UiSmsListModule {}
